import { useTranslation } from "react-i18next";

import type { TaskStatus } from "@/api/queries";
import { Badge } from "@/components/ui/badge";
import { NativeSelect } from "@/components/ui/input";
import { cn } from "@/lib/utils";

import { statusBadge, taskStatuses } from "./lib";

export function TaskStatusBadge({ status }: { status: TaskStatus }) {
  const { t } = useTranslation();
  return <Badge variant={statusBadge[status]}>{t(`tasks.status.${status}`)}</Badge>;
}

type TaskStatusSelectProps = {
  value: TaskStatus;
  onChange: (status: TaskStatus) => void;
  label: string;
  disabled?: boolean;
  className?: string;
};

/** Status picker for people allowed to move the task. */
export function TaskStatusSelect({ value, onChange, label, disabled, className }: TaskStatusSelectProps) {
  const { t } = useTranslation();
  return (
    <NativeSelect
      aria-label={label}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as TaskStatus)}
      className={cn("h-8 text-sm", className)}
    >
      {taskStatuses.map((s) => (
        <option key={s} value={s}>
          {t(`tasks.status.${s}`)}
        </option>
      ))}
    </NativeSelect>
  );
}
